import { ClientProfileViewModel } from '@common/model/client';
import { SxProps } from '@cp/ds/src/theme';
import { ModerationToggle, ModerationToggleVariant } from 'src/features/moderation/moderationToggle';
import { coreClientProfileApi } from 'src/entities/clientProfile';

export const ToggleClientDocumentsCheck = ({
  clientProfile,
  variant = 'default',
  sx,
}: {
  clientProfile?: ClientProfileViewModel;
  variant?: ModerationToggleVariant;
  sx?: SxProps;
}) => {
  const [toggleClientDocumentsCheck] = coreClientProfileApi.endpoints.toggleClientDocumentsCheck.useMutation();

  return (
    <ModerationToggle
      checked={clientProfile?.isDocumentsChecked ?? false}
      disabled={!clientProfile}
      label="Документы проверены"
      onChange={() => {
        if (!clientProfile) return;
        toggleClientDocumentsCheck({ clientId: clientProfile.id });
      }}
      sx={sx}
      variant={variant}
    />
  );
};
